import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import './ResultsGroupView.css';
import './Explore.css';

const ResultsGroupView = (props) => {
  if (props.loading) {
    return (
      <div>
        <br />
        <div> Loading data.... </div>
        <br />
        <LinearProgress color="secondary" />
      </div>
    );
  }
  /* eslint-disable react/no-array-index-key */
  return (
    <div className="grid-container-xxl ResultsGroupView">
      {props.groups.map((group, index) => (
        <div className="row grid-container-xxl ResultsGroupView" key={index}>
          <div className="ResultsGroupView-group-title-outer">
            <div className="ResultsGroupView-group-title-inner">{group.name}</div>
          </div>
          <div className="grid-container-xxl ResultsGroupView-group-items">
            {group.items.map((item, itemIndex) => (
              <div className="ResultsGroupView-list-item" key={itemIndex}>
                {item}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResultsGroupView;
